import { Bag } from "@/components/Icons";
import { OrderStorage } from "@/storage/OrderStorage";

import styles from "@/styles/containers/cart-shortcut.module.scss";
import { Currency } from "@/tools";

import classNames from "classnames/bind";
import { useTranslations } from "next-intl";
const css = classNames.bind(styles);

export const CartShortcut = ({ onOpenCart }) => {
  const t = useTranslations();

  const cart = OrderStorage.getOrder()?.cart;
  const cartItemsCount = cart?.catalog?.items.reduce(
    (t, i) => t + (i.quantity || 1),
    0
  );
  const cartHasProducts = cart?.catalog?.items?.length > 0;

  return (
    <div
      className={css({
        cartShortcut: true,
        empty: !cartHasProducts,
        hasProducts: cartHasProducts,
      })}
      onClick={onOpenCart}
    >
      <div className={styles.icon}>
        <Bag />
      </div>
      {!cartHasProducts ? (
        <p>{t("pendingItems")}</p>
      ) : (
        <>
          <span className={styles.quantity}>{cartItemsCount}</span>
          <p>{Currency.formatCurrency(OrderStorage.getOrder()?.cart?.total)}</p>
        </>
      )}
    </div>
  );
};
